"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Steps = void 0;
const antd_1 = require("antd");
Object.defineProperty(exports, "Steps", { enumerable: true, get: function () { return antd_1.Steps; } });
